"use client";

import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { workspaceAppsApi } from "../api";
import { workspaceAppsKeys } from "../queryKeys";

export function useEffectiveWorkspaceApplicationsQuery(
  userUuid: string,
  workspaceUuid: string,
) {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: workspaceAppsKeys.effective(userUuid, workspaceUuid),
    queryFn: ({ signal }) => (
      workspaceAppsApi.listEffectiveApplications(workspaceUuid, { signal })
    ),
    enabled: userUuid !== "" && workspaceUuid !== "",
  });

  useEffect(() => {
    const isAnotherIdentity = (queryKey: readonly unknown[]): boolean => (
      queryKey[0] === "workspace-apps"
      && queryKey[2] === "effective"
      && queryKey[3] !== userUuid
    );

    void queryClient.cancelQueries({
      predicate: (cachedQuery) => isAnotherIdentity(cachedQuery.queryKey),
    });
    queryClient.removeQueries({
      predicate: (cachedQuery) => isAnotherIdentity(cachedQuery.queryKey),
    });
  }, [queryClient, userUuid]);

  return query;
}
